import { Component, ViewContainerRef } from '@angular/core';
import { NavController, NavParams, PopoverController, ToastController, AlertController } from 'ionic-angular';
import { DIC } from '../../dic';
import { GN } from '../../../gn';
import { PopupPage } from '../../popup/popup';

/**
 * Generated class for the EditbeaconsettingsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-editbeaconsettings',
  templateUrl: 'editbeaconsettings.html',
})
export class EditbeaconsettingsPage {
  loadingData: boolean = false;
  Organisations: any;
  bk: any;
  cb: any;
  Title = ''
  beaconcode: string = ''
  beaconinfo: string = ''
  beaconid: string = ''
  beacontype: string = ''
  beaconvehicle: string = ''
  beaconvehicleid = -1
  beaconemployee: string = ''
  beaconemployeeid = -1
  beaconasset: string = ''
  beaconassetid = -1
  allbk = []
  alldrivers = []
  allassets = []

  public toggle: boolean = false;


  constructor(public navCtrl: NavController, public navParams: NavParams, public dic: DIC, public gn: GN, public popoverCtrl: PopoverController, public toastCtrl: ToastController, public alertCtrl: AlertController, public vcRef: ViewContainerRef) {
    this.bk = navParams.get('bk')
    this.allbk = navParams.get('allbk')
    this.cb = navParams.get('cb');
    this.beaconvehicle = this.dic.l["choosevehicle"]
    this.beaconemployee = this.dic.l["chooseemployee"]
    this.beaconasset = this.dic.l["chooseasset"]
    this.beacontype = this.dic.l["choosebeacontype"]
    // console.log('bosko kocev',this.gr)
    if (this.bk.id == -1) {
      this.Title = this.dic.l["addnewbeacon"]
    } else {
      this.Title = this.dic.l["editbeacon"]

      this.beaconcode = this.bk.code
      this.beaconinfo = this.bk.info
      this.beaconid = this.bk.beaconid
      this.beacontype = this.bk.typedesc
      this.beaconvehicle = this.bk.vehicle
      this.beaconvehicleid = this.bk.vehicleid
      this.beaconemployee = this.bk.vehicle
      this.beaconemployeeid = this.bk.vehicleid
      this.beaconasset = this.bk.vehicle
      this.beaconassetid = this.bk.vehicleid
    }
  }

  ionViewDidLoad() {
    // console.log(this.color44, 'daj da vidam')
    var _that = this
    this.gn._Post('/api/gn/getalldrivers', { cid: this.gn.crypt(this.gn.user.ClientId) }, function (_data) {
      _that.alldrivers = _data
    })
    this.gn._Post('/api/gn/getallassets', { cid: this.gn.crypt(this.gn.user.ClientId) }, function (_data) {
      _that.allassets = _data
    })
  }

  openBeaconType(_ev) {
    var _that = this
    let popover = this.popoverCtrl.create(PopupPage, {
      type: 'beacon-type', selected: [], callback: function (_text, _ids) {
        if ((_that.beacontype == 'PersonID' || _that.beacontype == 'Asset') && _text != 'PersonID' && _text != 'Asset') {
          _that.beaconvehicle = _that.dic.l["choosevehicle"]
          _that.beaconvehicleid = -1
        }
        if (_that.beacontype != 'PersonID' && _text == 'PersonID') {
          _that.beaconemployee = _that.dic.l["chooseemployee"]
          _that.beaconemployeeid = -1
        }
        if (_that.beacontype != 'Asset' && _text == 'Asset') {
          _that.beaconasset = _that.dic.l["chooseasset"]
          _that.beaconassetid = -1
        }
        _that.beacontype = _text
      }
    });
    popover.present({ ev: _ev });
  }

  openBeaconVehicle(_ev) {
    var _that = this
    let popover = this.popoverCtrl.create(PopupPage, {
      type: 'vehicles-beacon', selected: [], allbk: _that.allbk, callback: function (_text, _ids) {
        _that.beaconvehicleid = _ids
        _that.beaconvehicle = _text
      }
    });
    popover.present({ ev: _ev });
  }

  openBeaconEmployee(_ev) {
    var _that = this
    let popover = this.popoverCtrl.create(PopupPage, {
      type: 'employees-beacon', selected: [], allbk: _that.allbk, clientDrivers: _that.alldrivers, callback: function (_text, _ids) {
        _that.beaconemployeeid = _ids
        _that.beaconemployee = _text
      }
    });
    popover.present({ ev: _ev });
  }

  openBeaconAsset(_ev) {
    var _that = this
    let popover = this.popoverCtrl.create(PopupPage, {
      type: 'asset-beacon', selected: [], allbk: _that.allbk, clientAssets: _that.allassets, callback: function (_text, _ids) {
        _that.beaconassetid = _ids
        _that.beaconasset = _text
      }
      // });
      // popover.present({ ev: _ev });

    }, { cssClass: 'popover-content-rmech' });
    popover.present({ ev: _ev });
  }

  Save() {

    if (this.beaconcode == '') {
      let toast = this.toastCtrl.create({ message: this.dic.l["enterbeaconcode"], duration: 3000, position: 'top' });
      toast.present();
      return
    }
    if (this.beaconid == '') {
      let toast = this.toastCtrl.create({ message: this.dic.l["enterbeaconid"], duration: 3000, position: 'top' });
      toast.present();
      return
    }
    if (this.beacontype == this.dic.l["choosebeacontype"]) {
      let toast = this.toastCtrl.create({ message: this.dic.l["enterbeacontype"], duration: 3000, position: 'top' });
      toast.present();
      return
    }
    if (this.beacontype == 'PersonID') {
      if (this.beaconemployeeid == -1) {
        let toast = this.toastCtrl.create({ message: this.dic.l["enterbeaconemployee"], duration: 3000, position: 'top' });
        toast.present();
        return
      }
    } else {
      if (this.beacontype == 'Asset') {
        if (this.beaconassetid == -1) {
          let toast = this.toastCtrl.create({ message: this.dic.l["enterbeaconasset"], duration: 3000, position: 'top' });
          toast.present();
          return
        }
      } else {
        if (this.beaconvehicleid == -1) {
          let toast = this.toastCtrl.create({ message: this.dic.l["enterbeaconvehicle"], duration: 3000, position: 'top' });
          toast.present();
          return
        }
      }
    }

    this.beaconid = this.beaconid.toLowerCase()

    var _that = this;
    var dat = {
      bcode: this.gn.crypt(this.beaconcode),
      binfo: this.gn.crypt(this.beaconinfo),
      bid: this.gn.crypt(this.beaconid),
      btype: this.gn.crypt(this.beacontype),
      bvehicleid: this.beacontype == 'PersonID' ? this.gn.crypt(this.beaconemployeeid) : (this.beacontype == 'Asset' ? this.gn.crypt(this.beaconassetid) : this.gn.crypt(this.beaconvehicleid)),
      cid: this.gn.crypt(this.gn.user.ClientId)
    }
    //this.gn.disableBtn();
    this.gn.tfBtn = true;
    //debugger
    this.gn._Post('/api/gn/addnewbeacon', dat, function (_data) {
      _that.gn.tfBtn = false;
      if (_data.msg == 'EXIST') {
        let toast = _that.toastCtrl.create({ message: _that.dic.l["existbeaconid"], duration: 3000, position: 'top' });
        toast.present();
        return
      } else {
        _that.navCtrl.pop();
        _that.cb();
        //_that.gn.enableBtn();
      }
    })

  }

  Edit() {
    if (this.beaconcode == '') {
      let toast = this.toastCtrl.create({ message: this.dic.l["enterbeaconcode"], duration: 3000, position: 'top' });
      toast.present();
      return
    }
    if (this.beaconid == '') {
      let toast = this.toastCtrl.create({ message: this.dic.l["enterbeaconid"], duration: 3000, position: 'top' });
      toast.present();
      return
    }
    if (this.beacontype == this.dic.l["choosebeacontype"]) {
      let toast = this.toastCtrl.create({ message: this.dic.l["enterbeacontype"], duration: 3000, position: 'top' });
      toast.present();
      return
    }
    if (this.beacontype == 'PersonID') {
      if (this.beaconemployeeid == -1) {
        let toast = this.toastCtrl.create({ message: this.dic.l["enterbeaconemployee"], duration: 3000, position: 'top' });
        toast.present();
        return
      }
    } else {
      if (this.beacontype == 'Asset') {
        if (this.beaconassetid == -1) {
          let toast = this.toastCtrl.create({ message: this.dic.l["enterbeaconasset"], duration: 3000, position: 'top' });
          toast.present();
          return
        }
      } else {
        if (this.beaconvehicleid == -1) {
          let toast = this.toastCtrl.create({ message: this.dic.l["enterbeaconvehicle"], duration: 3000, position: 'top' });
          toast.present();
          return
        }
      }
    }

    // if (this.beaconid.length > 0) {
    this.beaconid = this.beaconid.toLowerCase()
    // }

    var _that = this;
    var dat = {
      bcode: this.gn.crypt(this.beaconcode),
      binfo: this.gn.crypt(this.beaconinfo),
      bid: this.gn.crypt(this.beaconid),
      btype: this.gn.crypt(this.beacontype),
      bvehicleid: this.beacontype == 'PersonID' ? this.gn.crypt(this.beaconemployeeid) : (this.beacontype == 'Asset' ? this.gn.crypt(this.beaconassetid) : this.gn.crypt(this.beaconvehicleid)),
      id: this.gn.crypt(this.bk.id),
      cid: this.gn.crypt(this.gn.user.ClientId)
    }
    this.gn.tfBtn = true;
    this.gn._Post('/api/gn/editbeacon', dat, function (_data) {
      _that.gn.tfBtn = false;
      if (_data.msg == 'EXIST') {
        let toast = _that.toastCtrl.create({ message: _that.dic.l["existbeaconid"], duration: 3000, position: 'top' });
        toast.present();
        return
      } else {
        _that.navCtrl.pop();
        _that.cb();
      }
    })

  }
}



// WEBPACK FOOTER //
// ./src/pages/settings/beaconsettings/editbeaconsettings.ts